var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-container",class:{'turned-on': _vm.turnedOn}},[_c('span',{staticClass:"off"},[_vm._v("Off")]),_c('span',{staticClass:"switch",on:{"click":_vm.toggle}},[_c('div',{staticClass:"circle"})]),_c('span',{staticClass:"on"},[_vm._v("On")])])
}
var staticRenderFns = []

export { render, staticRenderFns }